<template>
  <div class="imdiv" v-on:click="goArtistPortfolio">
    <div class="style-specialist" v-if="artistData.specialist && showStyleSpecialists">{{ $nippets.gallery.styleSpecialist }}</div>
    <div class="square-filler">
      <ix-router-link :to="'/artists/' + artist.portfolio_url"><transition name="fade"><img v-if="seen"
      :src="getImageUrl()" :alt="getAlt()" class="main absim" /></transition></ix-router-link>
    </div>
    <slide-show :slides="rollovers" :delay="300" />
    <grey-bar :likeImageId="imageId" :artist="artist" />
  </div>
</template>


<script>
//import GreyBar from '@/components/widgets/GreyBar.vue'
import GreyBar from '@/components/widgets/GreyBarNoDrop.vue'
import SlideShow from '@/components/widgets/SlideShow.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

export default {
  components: {
    GreyBar,
    SlideShow
  },
  mixins: [ ViewablePanel ],
  props: {
    artistData: Object,
    pageSettings: String,
    gallery: Object,
    showStyleSpecialists: Boolean
  },
  computed: {
    imageId () {
      return this.artistData.images[0].image_id
    }
  },
  data: function () {
    return {
      artist: { galleries: [] },
      rollovers: []
    }
  },
  created () {
    if(this.artistData.artist_id){
      this.loadArtist()
    }
  },
  methods: {
    goArtistPortfolio: function () {
      this.$emit('click', this.artist)
      // this gets called whatever gets clicked - which is nice
      let gid = Number(this.artistData.gallery_id)
      this.$apix.post('events/log-gallery-image', { imageid: this.imageId, galleryid: gid})
      
    },
    loadArtist: async function () {
      if(this.artistData) {
        this.artist = await this.$store.dispatch('fetchArtistById', this.artistData.artist_id)
        this.rollovers = this.artistData.images.slice(1)
        this.setInView()
      }
    },
    getImageUrl: function() {
      return this.$k.getImageCrop320(this.artistData.images[0].url)
    },
    getAlt () {
      if(this.gallery) {
        return this.artistData.images[0].alt || this.artist.formatted_name + ' ' + this.gallery.name
      }
      return this.artistData.images[0].alt || this.artist.formatted_name
    }
  },
  watch: {
    artistData: function () {
      if(this.artistData.artist_id) {
        this.loadArtist()
      }
    },
    pageSettings () {
      this.setInView()
    }
  }
}
</script>

<style>

img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}
.square-filler{
  position:relative;
  overflow:hidden;
}
.imdiv:hover img.main{
  width:107%;
}

.style-specialist{
  background-color:#fa4238;
  border-bottom-right-radius: 5px;
  color:#fff;
  font-size:14px;
  position:absolute;
  top:0;
  left:0;
  z-index:35;
  padding:4px 12px;
}

</style>
